export default {
	subtitle:
		'Elakadtál? Keresd meg a választ a lenyíló fülekre kattintva. Ha nem találnád továbbra sem azt, amit keresnél írj a titkarsag@mik.ma e-mail címre.',
};
